module.exports = __webpack_public_path__ + "677d2fc8a38d22db60b65510565be7d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/plunger-hat-s.png
// module id = 2936
// module chunks = 0